// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* html {
  scroll-behavior: smooth !important;
} */
.scrollbarHidden::-webkit-scrollbar {
  display: none;
}

.table-striped>tbody>tr:nth-child(2n+1)>td,
.table-striped>tbody>tr:nth-child(2n+1)>th {
  background-color: #F5F7FF;
}

.table-borderless>tbody>tr>td,
.table-borderless>tbody>tr>th,
.table-borderless>tfoot>tr>td,
.table-borderless>tfoot>tr>th,
.table-borderless>thead>tr>td,
.table-borderless>thead>tr>th {
  border: none;
  font-weight: normal;
}

.spinner {
  margin-top: -150px;
  width: 100vh;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner span {
  font-size: 2rem;
  animation: fade 1s linear 0s infinite;
  padding-right: 1rem;
}

.half-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #2c5FFE;
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: spin 0.5s linear 0s infinite;
}

.TextButton {
  text-decoration: none;
  color: #333333;
  padding: 2px 6px 2px 6px;
  border-top: 1px solid #CCCCCC;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #CCCCCC;
  border-radius: 8px;
  cursor: pointer;
}

@keyframes bigger {
  from {
    transform: scale(0);
  }

  to {
    transform: scale(2);
  }
}

@keyframes spin {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/html.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;EACE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* html {\n  scroll-behavior: smooth !important;\n} */\n.scrollbarHidden::-webkit-scrollbar {\n  display: none;\n}\n\n.table-striped>tbody>tr:nth-child(2n+1)>td,\n.table-striped>tbody>tr:nth-child(2n+1)>th {\n  background-color: #F5F7FF;\n}\n\n.table-borderless>tbody>tr>td,\n.table-borderless>tbody>tr>th,\n.table-borderless>tfoot>tr>td,\n.table-borderless>tfoot>tr>th,\n.table-borderless>thead>tr>td,\n.table-borderless>thead>tr>th {\n  border: none;\n  font-weight: normal;\n}\n\n.spinner {\n  margin-top: -150px;\n  width: 100vh;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.spinner span {\n  font-size: 2rem;\n  animation: fade 1s linear 0s infinite;\n  padding-right: 1rem;\n}\n\n.half-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #2c5FFE;\n  border-top: 3px solid transparent;\n  border-radius: 50%;\n  animation: spin 0.5s linear 0s infinite;\n}\n\n.TextButton {\n  text-decoration: none;\n  color: #333333;\n  padding: 2px 6px 2px 6px;\n  border-top: 1px solid #CCCCCC;\n  border-right: 1px solid #333333;\n  border-bottom: 1px solid #333333;\n  border-left: 1px solid #CCCCCC;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n@keyframes bigger {\n  from {\n    transform: scale(0);\n  }\n\n  to {\n    transform: scale(2);\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes fade {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
